import GoodsTracking from "@/pages/Acer/GoodsTracking"
import GoodsTrackingMap from "@/pages/Acer/GoodsTrackingMap"
import Index from "@/pages/Acer/Index"
import Search from "@/pages/Acer/Search"
import Th from "@/pages/Acer/th/Index"
import ThOrder from "@/pages/Acer/th/Order"
import ThGoods from "@/pages/Acer/th/Goods"
import ThTrans from "@/pages/Acer/th/Trans"
import ThFiles from "@/pages/Acer/th/Files"
import Sh from "@/pages/Acer/sh/Index"
import ShOrder from "@/pages/Acer/sh/Order"
import ShGoods from "@/pages/Acer/sh/Goods"
import ShTrans from "@/pages/Acer/sh/Trans"
import ShFiles from "@/pages/Acer/sh/Files"
import Thd from "@/pages/Acer/Thd"
import Psd from "@/pages/Acer/Psd"
import Abnormal from "@/pages/Acer/Abnormal"

let router = [{
    path: "/Acer/goods_tracking",
    name: "goods_tracking",
    component: GoodsTracking,
    meta: {
      title: "货物跟踪",
      keepAlive: true,
      login: false // 是否需要登录
    }
  }, {
    path: "/Acer/tracking_map",
    name: "tracking_map",
    component: GoodsTrackingMap,
    meta: {
      title: "运输轨迹",
      keepAlive: true,
      login: false // 是否需要登录
    }
  }, {
    path: "/Acer/",
    name: "Index",
    component: Index,
    meta: {
      title: "TMS运输管理系统",
      keepAlive: true
    }
  }, {
    path: "/Acer/thd",
    name: "thd",
    component: Thd,
    meta: {
      title: "提货单",
      role: [0]
    }
  }, {
    path: "/Acer/psd",
    name: "psd",
    component: Psd,
    meta: {
      title: "送货单",
      role: [0]
    }
  }, {
    path: "/Acer/search",
    name: "search",
    component: Search,
    meta: {
      title: "搜索"
    }
  }, {
    path: "/Acer/th",
    name: "th",
    component: Th,
    meta: {
      title: "提货单"
    },
    children: [{
      path: "/Acer/th/order",
      name: "order",
      component: ThOrder,
      meta: {
        title: "提货单信息"
      },
    }, {
      path: "/Acer/th/goods",
      name: "goods",
      component: ThGoods,
      meta: {
        title: "货物"
      },
    }, {
      path: "/Acer/th/trans",
      name: "trans",
      component: ThTrans,
      meta: {
        title: "物流"
      },
    }, {
      path: "/Acer/th/files",
      name: "files",
      component: ThFiles,
      meta: {
        title: "回单"
      },
    }]
  }, {
    path: "/Acer/sh",
    name: "sh",
    component: Sh,
    meta: {
      title: "送货单"
    },
    children: [{
      path: "/Acer/sh/order",
      name: "order",
      component: ShOrder,
      meta: {
        title: "送货单信息"
      },
    }, {
      path: "/Acer/sh/goods",
      name: "goods",
      component: ShGoods,
      meta: {
        title: "货物"
      },
    }, {
      path: "/Acer/sh/trans",
      name: "trans",
      component: ShTrans,
      meta: {
        title: "物流"
      },
    }, {
      path: "/Acer/sh/files",
      name: "files",
      component: ShFiles,
      meta: {
        title: "回单"
      },
    }]
  },
  {
    path: "/Acer/abnormal",
    name: "abnormal",
    component: Abnormal,
    meta: {
      title: "异常反馈",
      role: [0]
    }
  },{
    path: "/Acer/transfer",
    name: "transfer",
    component: () => import('@/pages/Acer/Transfer'),
    meta: {
      title: "中转",
      keepAlive: false,
      login: false
    }
  }
];
export default router;



// WEBPACK FOOTER //
// ./src/router/Acer.js